import { useCallback } from "react"
import { multiselectAnimationAction } from "../../store/slices/objects.slice/animation/multiselectAnimationAction"
import { useAppDispatch } from "../useRedux"

/**
 * Click handler for selecting an animation in the timeline.
 *
 * Subscription-free — it runs once per rendered tween. See `multiselectAnimationAction`.
 */
const useMultiselectAnimation = (animationId: string) => {
    const dispatch = useAppDispatch()

    const handleMultiselectAnimations = useCallback(
        (ctrlShiftKey: boolean) => {
            dispatch(multiselectAnimationAction(animationId, ctrlShiftKey))
        },
        [dispatch, animationId]
    )

    return { handleMultiselectAnimations }
}

export default useMultiselectAnimation
